export const validateEmail = (email) => {
  const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
  return validRegex.test(email);
};



export const validatePhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return true; // Empty is valid (not required)

  // Clean the number first (remove spaces, hyphens, parentheses, dots)
  const cleaned = phoneNumber.replace(/[\s\-\(\)\.]/g, '');

  // Use the same validation as backend for consistency
  // Backend regex: /^\+?[1-9]\d{6,14}$/
  const phoneRegex = /^\+?[1-9]\d{6,14}$/;
  return phoneRegex.test(cleaned);
};


export const validateUUID = (uuid) => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
};